var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerMas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.26 35.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 16otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.26 8.7 92.31 6.49 46.63 26.23 0.95 6.49 0 8.7 46.15 28.65 47.11 28.65 93.26 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.26 15.19 92.31 12.98 46.63 32.73 0.95 12.98 0 15.19 46.15 35.14 47.11 35.14 93.26 15.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.26 2.21 92.31 0 46.63 19.75 0.95 0 0 2.21 46.15 22.16 47.11 22.16 93.26 2.21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerMas);
export default __webpack_public_path__ + "static/media/ver-mas.925e4415fe239ce1f843c63a17141fef.svg";
export { ForwardRef as ReactComponent };